
import DeptTreeV1 from './main.vue';
import DeptTreeV2 from 'yxt-biz-pc/packages/dept-tree-v2/index';
import { getOrgpParameter } from './service';

let DeptTree = async function(resolve) {
  try {
    const res = await getOrgpParameter();
    if (res && res.value === '1') {
      resolve(DeptTreeV2);
    } else {
      resolve(DeptTreeV1);
    }
  } catch (error) {
    resolve(DeptTreeV1);
  }
};

export default {
  name: 'YxtbizDeptTree',
  functional: true,
  render(h, context) {
    let newDeptTree = null;
    if (context.props.version === 'v1' || context.props.selectAllSiblingNode) {
      // 如果手动设置了v1版本或者开启了选所有同级部门功能，直接使用v1版本
      newDeptTree = DeptTreeV1;
    } else {
      newDeptTree = DeptTree;
    }
    return h(newDeptTree, { ...context.data });
  }
};
